module.exports = __webpack_public_path__ + "img/feizhengchang.56c8feea.png";